<router-outlet></router-outlet>
<div class="loading-spinner-overlay" *ngIf="spinnerService.showSpinner">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
